import React, { Dispatch } from 'react'
import './TableActionsCell.scss'
import { Button } from '../../../../../ps-aspect-design';
import { MinimumWageTableI, MinimumWageReducerAction } from './store';

export const TableActionsCell = ({ data, dispatch } : {
    data: MinimumWageTableI
    dispatch: Dispatch<MinimumWageReducerAction>
    }) => (
    <div className='table-actions-cell'>
        <Button icon='Pencil' variant='secondary' onClick={() =>  dispatch({ type: 'SET_EDIT_MODAL_OPEN', payload: data })}>Edit</Button>
        <Button icon='Trash' variant='danger' onClick={() =>  dispatch({ type: 'SET_DELETE_MODAL_OPEN', payload: data })}>Delete</Button>
    </div>
)
